// client/src/components/common/ToastContainer.jsx
import { CheckCircle2, AlertCircle, AlertTriangle, Info, X } from 'lucide-react';

export const ToastContainer = ({ toasts = [], onRemove }) => {
  if (!toasts.length) return null;

  const icons = {
    success: <CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />,
    error: <AlertCircle className="w-5 h-5 text-red-600 shrink-0 mt-0.5" />,
    warning: <AlertTriangle className="w-5 h-5 text-amber-600 shrink-0 mt-0.5" />,
    info: <Info className="w-5 h-5 text-blue-600 shrink-0 mt-0.5" />,
  };

  const borders = {
    success: 'border-l-4 border-l-emerald-500',
    error: 'border-l-4 border-l-red-500',
    warning: 'border-l-4 border-l-amber-500',
    info: 'border-l-4 border-l-blue-500',
  };

  return (
    <div
      className="fixed top-5 right-5 z-[9999] flex flex-col gap-2.5 pointer-events-none max-w-sm w-full px-4 sm:px-0"
      aria-live="polite"
      role="region"
      aria-label="Notificaciones"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className={`pointer-events-auto bg-white rounded-xl shadow-xl border border-gray-100 p-4 flex items-start gap-3 transition-all transform animate-in slide-in-from-top-2 duration-200 ${
            borders[t.type] || borders.info
          }`}
        >
          {icons[t.type] || icons.info}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-gray-800 leading-snug break-words">
              {t.message}
            </p>
          </div>
          <button
            type="button"
            onClick={() => onRemove(t.id)}
            className="text-gray-400 hover:text-gray-600 p-0.5 rounded-md hover:bg-gray-100 transition-colors"
            title="Cerrar notificación"
            aria-label="Cerrar notificación"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ToastContainer;
